module.exports = __webpack_public_path__ + "static/media/zodiac-Pisces.8e478d25.png";